import { DecorItemI } from "../../../shared";

export const removeDecor = (decorItemId: string, decors: DecorItemI[]) => {
    return decors.filter((decor) => decor.id !== decorItemId)
};
